"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateProdConfigBy = void 0;
function generateProdConfigBy(config) {
    var ENV_NAME = config.ENV_NAME, HOST_ENDPOINT = config.HOST_ENDPOINT, CMS_PROXY_NO_APIC_ENDPOINT = config.CMS_PROXY_NO_APIC_ENDPOINT, NETWORK_CONFIG = config.NETWORK_CONFIG;
    return {
        ENV_NAME: ENV_NAME,
        CMS_PROXY_ENDPOINT: "/api/:api_type/cms-proxy",
        CMS_PROXY_NO_APIC_ENDPOINT: CMS_PROXY_NO_APIC_ENDPOINT,
        HOST_ENDPOINT: HOST_ENDPOINT,
        REVALIDATE_TOKEN: "prova",
        PRODOTTO_UNICO_ACTIVE: "",
        NETWORK_CONFIG: NETWORK_CONFIG,
    };
}
exports.generateProdConfigBy = generateProdConfigBy;
